var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.389,
    height: 15.488,
    viewBox: "0 0 18.389 15.488",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b,.c{fill:none;stroke:currentColor;}.a{stroke-linecap:round;}.a,.c{stroke-linejoin:round;}.b{stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M48.717,151.8h3.2l1.828,8.82s.046.188.054.231c.417,2.285,1.59,2.78,2.788,2.78h6.476",
    transform: "translate(-48.717 -151.802)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M97.758,194.76a1.329,1.329,0,1,1-1.329-1.329A1.329,1.329,0,0,1,97.758,194.76Z",
    transform: "translate(-81.918 -181.601)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M62.176,160.548l13.564.911-1.768,5.455-10.5,0",
    transform: "translate(-58.351 -158.062)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M71.316,194.76a1.329,1.329,0,1,1-1.329-1.329A1.329,1.329,0,0,1,71.316,194.76Z",
    transform: "translate(-62.99 -181.601)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 12.106,
    transform: "translate(4.508 5.755)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    y2: 5.823,
    transform: "translate(10.302 2.951)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 0.795,
    y2: 5.533,
    transform: "translate(13.066 3.213)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 0.87,
    y2: 6.132,
    transform: "translate(6.715 2.693)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/Cart.01ba52016d734f3a6cc5542eceeaff54.svg";
export { ForwardRef as ReactComponent };